export const LOCAL_STORAGE_FILTER_KEY = 'pj:filterExpanded';
export const sortOptions = ['name', 'popularity', 'user_reviews'] as const;
export const bothDirectionsSortOptions = [
  'price',
  'price_include_shipping',
] as const;
